// #154: FIRST, before any module reads the location (see the module)
import './startup/canonicalize';

// #189 (ra#499 S3): the entry branches before anything of the app is EVALUATED:
// utils/helpers.tsx reads localStorage at load, which throws in the sandboxed
// admin preview, and App starts session timers. `eager` keeps appMain and its
// CSS in the initial bundle, in today's order, with no extra request for a
// visitor; it is only not evaluated before this line. The preview is a chunk
// of its own.
if (/\/theme-preview\/?$/.test(window.location.pathname)) {
  void import('./preview/previewMain');
} else {
  void import(/* webpackMode: "eager" */ './appMain');
}

export {};
